import React, {useState, useEffect} from 'react';
import {PageMetaData} from "./components/common/paget-meta-data";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "./store";
import {LanguageContext} from "./LanguageContext";
import {useParams} from "react-router-dom";
import i18n from "./i18n";
import {getAvailableLanguages} from "./components/common/languages-helper";
import {useTranslation} from "react-i18next";
import TherapistDashboard from "./components/pages/therapist-dashboard/TherapistDashboard";
import TherapySession from "./components/pages/therapy-session/TherapySession";
import Loader from "./components/navigation/Loader";
import Portal from "./components/pages/portal/Portal";
import HostSession from "./components/pages/therapy-session/host-session/HostSession";
import VisitorSession from "./components/pages/therapy-session/visitor-session/VisitorSession";
import BeforeClientStartJoin from "./components/pages/therapy-session/visitor-session/BeforeClientStartJoin";
import LoginNavigation from "./components/navigation/login/LoginNavigation";
import Profile from "./components/pages/profile/Profile";
import ProfileSettings from "./components/pages/profile/ProfileSettings";
import Landing from "./components/pages/landing/Landing";
import Faq from "./components/pages/faq/Faq";
import Cennik from "./components/pages/cennik/Cennik";

//function RoutesHandler(props:{setPageMetaData:any, setCurrentWizardStep:any, isAuthenticated:boolean, isPageLoading:boolean, loginWithRedirect:any, profileData:any, setProfileData:any, setIsTalkingPage:any, setIsHomePage:any, loginFunction:any}) {
interface RoutesHandlerProps {
    isAuthenticated:boolean,
    loginFunction:any,
    logout:any,
    isLoading: boolean
}
const RoutesHandler:React.FC<RoutesHandlerProps> = ({isAuthenticated,isLoading,logout,loginFunction}) => {
    const { setLang } = React.useContext(LanguageContext);
    const {t} = useTranslation();
    let { langId } = useParams<{ langId: string }>();
    let { pageUrlPart } = useParams<{ pageUrlPart: string }>();
    const languageReloadStarted = React.useRef(false);

    React.useEffect(() => {
        //@ts-ignore
        if(getAvailableLanguages().includes(langId)) {
            i18n.changeLanguage(langId);
        }
    }, [langId, setLang]);

    const profileData = useSelector((state: RootState) => state.profile);
    // const dispatch = useDispatch();
    const availableLanguages = getAvailableLanguages();
    if(!pageUrlPart && langId && !availableLanguages.includes(langId)) {
        //when the first part of the url is not a language
        pageUrlPart = langId;
        langId = 'pl';
    }
    if(!langId && !pageUrlPart) {
        //when it is a main page - check preferred language
        const preferredLang = localStorage.getItem('lang');
        if(preferredLang && preferredLang !== 'pl' && availableLanguages.includes(preferredLang)) {
            //when visiting homepage without the language prefix, and we have in local storage that the language is not Polish - redirect
            //
            // …but never while Auth0 is still initialising. The Auth0
            // redirect_uri is window.location.origin, so every login comes back
            // to "/?code=…&state=…" — exactly this branch. auth0-react deletes
            // the one-time login transaction *before* it posts the code to
            // /oauth/token, so a reload here aborts that request and burns the
            // code: the user lands on /en signed out, with no error anywhere.
            // isLoading only turns false once handleRedirectCallback has
            // finished (or failed) and the SDK has cleaned the URL, so the
            // reload below is safe from that moment on.
            //
            // Assign once: App.tsx may follow up with a `redirect_after_login`
            // navigation (the protected deep link that started the login), and
            // re-assigning href on a later render would cancel it.
            if(!isLoading && !languageReloadStarted.current) {
                languageReloadStarted.current = true;
                window.location.href =  "/" + preferredLang;
            }
            return <Loader />;
        } else {
            langId = 'pl';
        }
    }
    if(isLoading || isAuthenticated && !profileData._id) {
        return <Loader />;
        // return <LoginNavigation isAuthenticated={} loginFunction={} logout={}
    }

    if(!langId && !pageUrlPart) {
        //main page
    }  else if(!langId || langId === "pl") {
        //when no language is set - it is English
        langId = 'pl';
        //when it is a default language - we remove the language part
        localStorage.removeItem('lang');
    } else if(langId !== 'pl') {
        localStorage.setItem('lang', langId);
    }

    if(pageUrlPart?.substring(0,"jsession-".length) === "jsession-") {
        const sessionId = pageUrlPart.split('-').pop();
        if(sessionId) {
            return <BeforeClientStartJoin sessionId={sessionId}/>
        } else {
            return <div>not found</div>;
        }
    } else if(pageUrlPart?.substring(0,"csession-".length) === "csession-") {
        const sessionId = pageUrlPart.split('-').pop();
        if(sessionId) {
            return <VisitorSession sessionId={sessionId}/>
        } else {
            return <div>not found</div>;
        }
    } else if(pageUrlPart === "faq") {
        // Public FAQ page — reachable whether or not the visitor is signed in.
        return <Faq />
    } else if(pageUrlPart === "cennik") {
        // Public pricing page — reachable whether or not the visitor is signed in.
        return <Cennik loginFunction={loginFunction} isAuthenticated={isAuthenticated} />
    } else if(!isAuthenticated) {
        if(!pageUrlPart) {
            // Unauthenticated main page: show the public marketing landing page
            // instead of the bare Sign In / Sign Up text link.
            return <Landing loginFunction={loginFunction} />
        }
        // Protected app routes auto-login (seamless when an Auth0 SSO session
        // from emdrlink.pl already exists). Public routes (faq / cennik /
        // csession- / jsession- / landing) are handled above, so they never
        // reach here.
        const isProtectedRoute =
            pageUrlPart === "therapist" ||
            pageUrlPart === "portal" ||
            pageUrlPart === "profile" ||
            pageUrlPart.startsWith("session-");
        if(isProtectedRoute) {
            return <ForceLogin loginFunction={loginFunction} />
        }
        return <div style={{textAlign:"center", marginTop:"45vh"}}> {' '}
            <a href={"#"} onClick={(event:any)=>{loginFunction(null,event)}}>{t("Sign In")}</a> /  <a href={"#"} onClick={(event:any) => loginFunction({authorizationParams: { screen_hint: "signup" }},event)}>{t("Sign Up")}</a>
        </div>
    } else if(!profileData.agreement) {
        return <Profile formTitle={t("Please complete your profile")} />
    } else if(!pageUrlPart) {
        // Land authenticated therapists straight on their dashboard (list of
        // invites/sessions) instead of the intermediate Home screen, which only
        // held a "go to the therapist portal" link.
        return <TherapistDashboard />
    }
    else if(pageUrlPart === "therapist") {
        return <TherapistDashboard />
    } else if(pageUrlPart?.substring(0,"session-".length) === "session-") {
        const sessionId = pageUrlPart.split('-').pop();
        if(sessionId) {
            return <HostSession sessionId={sessionId}/>
        } else {
            return <div>not found</div>;
        }
    } else if(pageUrlPart === "portal"){
        return <Portal />
    } else if(pageUrlPart === "profile"){
        return <ProfileSettings />
    } {
        return <div>404 NOT FOUND</div>
    }
}
// Auto-login gate for protected routes. On first hit it triggers a top-level
// Auth0 redirect (which returns immediately, no login form, when an SSO session
// already exists — e.g. the user is signed in on emdrlink.pl). It records the
// intended path so App.tsx sends the user back after auth. If we come back still
// unauthenticated (login cancelled), it stops and offers a manual Sign In rather
// than looping — the guard is cleared by App.tsx once a token is acquired.
const ForceLogin: React.FC<{loginFunction: any}> = ({loginFunction}) => {
    const {t} = useTranslation();
    const alreadyTried = sessionStorage.getItem('auth_interactive_retry');
    useEffect(() => {
        if(!alreadyTried) {
            sessionStorage.setItem('auth_interactive_retry', '1');
            localStorage.setItem('redirect_after_login', window.location.pathname + window.location.search);
            loginFunction();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if(alreadyTried) {
        return <div style={{textAlign:"center", marginTop:"45vh"}}>
            <a href={"#"} onClick={(event:any)=>{loginFunction(null,event)}}>{t("Sign In")}</a>
        </div>;
    }
    return <Loader />;
};

export default RoutesHandler;
